import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import Gallery from './Pages/Gallery';
import Testimonials from './Pages/Testimonials';
import About from './Pages/About';
import ContactUs from './Pages/ContactUs';
import BookAppoinment from './Pages/BookAppoinment';
import NavBar from './Components/NavBar';
import Footer from './Components/Footer';
import TeethWhitening from './Pages/DropDownContent/TeethWhitening';
import DentalImplants from './Pages/DropDownContent/DentalImplants';
import DenturesBridges from './Pages/DropDownContent/DenturesBridges';
import Filling from './Pages/DropDownContent/Filling';
import OralSurgery from './Pages/DropDownContent/OralSurgery';
import RootCanals from './Pages/DropDownContent/RootCanals';
import LasarDentisry from './Pages/DropDownContent/LasarDentisry';
import TeethReshaping from './Pages/DropDownContent/TeethReshaping';
import TeethCleaning from './Pages/DropDownContent/TeethCleaning';

function Main() {
  const openWhatsApp = () => {
    const phoneNumber = '+919698704907'; // Replace with your WhatsApp number
    const message = encodeURIComponent('Hello! I would like to book an appointment.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/bookanappointment" element={<BookAppoinment />} />
        <Route path='/TeethWhitening' element={<TeethWhitening/>} />
        <Route path='/DentalImplants' element={<DentalImplants/>} />
        <Route path='/DenturesBridges' element={<DenturesBridges/>} />
        <Route path='/FillingandSealants' element={<Filling/>} />
        <Route path='/OralSurgery' element={<OralSurgery/>} />
        <Route path='/RootCanals' element={<RootCanals/>} />
        <Route path='/LaserDentistry' element={<LasarDentisry/>} />
        <Route path='/TeethReshaping' element={<TeethReshaping/>} />
      </Routes>
      <Footer />

      {/* WhatsApp Button */}
      <div
        onClick={openWhatsApp}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#25D366',
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // WhatsApp logo
          alt="WhatsApp"
          style={{ width: '35px', height: '35px' }}
        />
      </div>
    </div>
  );
}

export default Main;
